// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { connect, useDispatch, useStore, useSelector } from '/Users/jeremy/code/web/abcBillGift-super/node_modules/.pnpm/@umijs+plugins@4.6.33_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28___430e381b00d0a369d880a779b4289295/node_modules/@umijs/plugins/libs/dva.tsx';
export { getDvaApp } from './dva';
